import React, { useState } from "react";
import { useForm } from "react-hook-form";
import uploadImg from "../utils/uploadImageToCloudinary";
import { TiDelete } from "react-icons/ti";
import { HiX } from "react-icons/hi";
import axios from "axios";
import toast from "react-hot-toast";

function AddStaff({ onClose, getAllStaffs }) {
  const [profilePic, setProfilePic] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUploadImage = async (file) => {
    const imageUrl = await uploadImg(file);

    setProfilePic(imageUrl);
  };

  //Initializing react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    setLoading(true);

    const finalData = {
      ...data,
      profilePic: profilePic,
    };

    console.log("Final Data to be submitted: ", finalData);

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/user/create-user`,
      headers: {},
      data: finalData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of onSubmit: ", response.data);
        setLoading(false);
        onClose();
        getAllStaffs();
        toast.success(response.data.message);
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error:", error);

        // Extract and display the specific error message
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          toast.error(error.response.data.error); // Display the actual error from the backend
        } else {
          toast.error("Error in creating staff");
        }
      });
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm backdrop-brightness-75 "
      onClick={onClose}
    >
      <div
        className="relative h-[80%] w-[95%] max-w-3xl overflow-y-auto rounded-lg bg-white p-4 shadow-lg md:p-8 lg:h-auto lg:px-6 lg:py-8"
        onClick={(e) => e.stopPropagation()}
      >
        <HiX
          className="absolute right-4 top-4 cursor-pointer text-primary hover:text-red-500"
          size={20}
          onClick={onClose}
        />
        <h1 className="text-center text-3xl font-bold tracking-wide text-primary">
          Add Staff
        </h1>

        {/* Input Fields */}
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="my-4 grid grid-cols-1 gap-4 md:grid-cols-2"
        >
          {/* Name */}
          <div className="col-span-2 flex flex-col gap-2 md:col-span-1">
            <label
              htmlFor="name"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Name <span className="text-red-500">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Name"
              {...register("name", { required: "Name is required" })}
              className={`rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.name ? "border-red-500" : "border-gray-800"
              }}`}
            />

            {errors.name && (
              <span className="text-sm text-red-500">
                {errors.name.message}
              </span>
            )}
          </div>

          {/* Phone */}
          <div className="col-span-2 flex flex-col gap-2 md:col-span-1">
            <label
              htmlFor="phone"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Phone Number <span className="text-red-500">*</span>
            </label>

            <input
              type="tel"
              placeholder="Enter Phone Number"
              {...register("phone", {
                required: "Phone Number is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Invalid Mobile Number",
                },
              })}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 10);
              }}
              className={`rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.phone ? "border-red-500" : "border-gray-800"
              }}`}
            />

            {errors.phone && (
              <span className="text-sm text-red-500">
                {errors.phone.message}
              </span>
            )}
          </div>

          {/* Email */}
          <div className="col-span-2 flex flex-col gap-2 md:col-span-1">
            <label
              htmlFor="email"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Email <span className="text-red-500">*</span>
            </label>

            <input
              type="email"
              placeholder="Enter Email"
              {...register("email", { required: "Email is required" })}
              className={`rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.email ? "border-red-500" : "border-gray-800"
              }}`}
            />

            {errors.email && (
              <span className="text-sm text-red-500">
                {errors.email.message}
              </span>
            )}
          </div>

          {/* Gender */}
          <div className="col-span-2 flex flex-col gap-2 md:col-span-1">
            <label
              htmlFor="gender"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Gender <span className="text-red-500">*</span>
            </label>

            <select
              name="gender"
              id="gender"
              {...register("gender", { required: "Gender is required" })}
              className={`rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.gender ? "border-red-500" : "border-gray-800"
              }}`}
            >
              <option value="" selected>
                Select gender
              </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>

            {errors.gender && (
              <span className="text-sm text-red-500">
                {errors.gender.message}
              </span>
            )}
          </div>

          {/* Date of Birth */}
          <div className="col-span-2 flex flex-col gap-2 md:col-span-1">
            <label
              htmlFor="dateOfBirth"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Date of Birth <span className="text-red-500">*</span>
            </label>

            <input
              type="date"
              placeholder="Enter Date of Birth"
              {...register("dateOfBirth", { required: "Email is required" })}
              className={`rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.dateOfBirth ? "border-red-500" : "border-gray-800"
              }}`}
            />

            {errors.dateOfBirth && (
              <span className="text-sm text-red-500">
                {errors.dateOfBirth.message}
              </span>
            )}
          </div>

          {/* Nationality */}
          <div className="col-span-2 flex flex-col gap-2 md:col-span-1">
            <label
              htmlFor="nationality"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Nationality <span className="text-red-500">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Nationality"
              {...register("nationality", {
                required: "Nationality is required",
              })}
              className={`rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.nationality ? "border-red-500" : "border-gray-800"
              }}`}
            />

            {errors.nationality && (
              <span className="text-sm text-red-500">
                {errors.nationality.message}
              </span>
            )}
          </div>

          {/* Address */}
          <div className="col-span-2 flex flex-col gap-2 ">
            <label
              htmlFor="address"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Address
            </label>

            <textarea
              type="text"
              placeholder="Enter Address"
              {...register("address")}
              className={`resize-none rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.address ? "border-red-500" : "border-gray-800"
              }}`}
            />
          </div>

          {/* Profile Pic */}
          <div className="col-span-2 flex flex-col gap-2 md:col-span-1">
            <label
              htmlFor="profilePic"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Profile Picture
            </label>

            <input
              type="file"
              accept="Image/*"
              className={`rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.profilePic ? "border-red-500" : "border-gray-800"
              }}`}
              onChange={(e) => handleUploadImage(e.target.files[0])}
            />

            {errors.profilePic && (
              <span className="text-sm text-red-500">
                {errors.profilePic.message}
              </span>
            )}
            <div className="relative">
              <img src={profilePic} className=" w-20 rounded" alt="" />
              {profilePic && (
                <TiDelete
                  className="absolute -top-2 left-20 cursor-pointer text-red-500"
                  size={18}
                  onClick={() => setProfilePic("")}
                />
              )}
            </div>
          </div>

          {/* Password */}
          <div className="col-span-2 flex flex-col gap-2 md:col-span-1">
            <label
              htmlFor="password"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Password <span className="text-red-500">*</span>
            </label>

            <input
              type="password"
              placeholder="Enter Password"
              {...register("password", { required: "Password is required" })}
              className={`rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.password ? "border-red-500" : "border-gray-800"
              }}`}
            />

            {errors.password && (
              <span className="text-sm text-red-500">
                {errors.password.message}
              </span>
            )}
          </div>

          {/* Buttons */}
          <button
            type="button"
            className="mt-4 hidden w-1/2 rounded bg-gray-200 py-2 font-semibold tracking-wide text-gray-800 shadow-md hover:bg-gray-400 md:block md:w-full "
            onClick={() =>
              reset({
                name: "",
                phone: "",
                email: "",
                dateOfBirth: null,
                gender: "",
                address: "",
                profilePic: "",
                nationality: "",
                password: "",
              })
            }
          >
            Clear
          </button>

          <button
            type="submit"
            className=" mt-4 hidden w-1/2 items-center justify-center  rounded bg-primary py-2 font-semibold tracking-wide text-white shadow-md hover:bg-hoverPrimary md:flex md:w-full"
          >
            {loading ? <div className="loaderButton"></div> : "Submit"}
          </button>

          <div className="flex items-center justify-between gap-2 md:hidden">
            <button
              type="button"
              className="mt-4 w-1/2 rounded bg-gray-200 py-2 font-semibold tracking-wide text-gray-800 shadow-md hover:bg-gray-400  md:w-full "
              onClick={() =>
                reset({
                  name: "",
                  phone: "",
                  email: "",
                  dateOfBirth: null,
                  gender: "",
                  address: "",
                  profilePic: "",
                  nationality: "",
                  password: "",
                })
              }
            >
              Clear
            </button>

            <button
              type="submit"
              className=" mt-4 flex w-1/2 items-center  justify-center rounded bg-primary py-2 font-semibold tracking-wide text-white shadow-md hover:bg-hoverPrimary md:w-full"
            >
              {loading ? <div className="loaderButton"></div> : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddStaff;
